import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { chipColumn, monoColumn, nameColumn } from 'library/components/DataTable/cells';
import ListScreen, { listPager, usePagedRows } from 'library/components/ListScreen';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
var AccountTypes = function (props) {
    var t = props.translate;
    var accountTypeService = services.accountTypeService;
    var _a = accountTypeService.useAccountTypes(), accountTypes = _a.data, isLoading = _a.isLoading;
    var _b = useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var debounceRef = useRef(undefined);
    var filtered = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        return (accountTypes || []).filter(function (accountType) {
            if (!query)
                return true;
            return [accountType.getName(), accountType.getNature(), String(accountType.getId())]
                .join(' ')
                .toLowerCase()
                .includes(query);
        });
    }, [accountTypes, searchValue]);
    var _c = usePagedRows(filtered), page = _c.page, setPage = _c.setPage, pages = _c.pages, from = _c.from, to = _c.to, pageRows = _c.pageRows;
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () {
            setPage(1);
            setSearchValue(value);
        }, 300);
    };
    var columns = useMemo(function () { return [
        monoColumn({ key: 'id', title: t('id'), width: '88px', value: function (accountType) { return accountType.getId(); } }),
        nameColumn({ key: 'name', title: t('name'), width: 'minmax(220px, 1.6fr)', value: function (accountType) { return accountType.getName(); } }),
        chipColumn({ key: 'nature', title: t('nature'), width: 'minmax(180px, 1fr)', tone: 'is-sky', value: function (accountType) { return accountType.getNature(); } })
    ]; }, [t]);
    return (_jsx(ListScreen, { title: t('header.accountTypes'), count: t('countBadge', { count: (accountTypes === null || accountTypes === void 0 ? void 0 : accountTypes.length) || 0 }), subtitle: t('subtitle'), search: { placeholder: t('searchPlaceholder'), onChange: onSearchValueChange }, children: _jsx(DataTable, { compact: true, minWidth: "520px", loading: isLoading, rows: pageRows, rowKey: function (accountType) { return accountType.getId(); }, empty: _jsx(EmptyComponent, { description: t('empty') }), columns: columns, pager: listPager({
                total: filtered.length,
                page: page,
                pages: pages,
                meta: t('showingRange', { from: from, to: to, total: filtered.length }),
                previous: t('previous'),
                next: t('next'),
                center: t('pageOf', { page: page, pages: pages }),
                setPage: setPage
            }) }) }));
};
export default localeTranslator(AccountTypes, 'accountTypes');
